export enum StorageKey {
  Token = 'token',
  Username = 'username',
}
